import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_COST_PROVIDER_LOADING = 'GET_COST_PROVIDER_LOADING';
export const GET_COST_PROVIDER_SUCCESS = 'GET_COST_PROVIDER_SUCCESS';
export const GET_COST_PROVIDER_REJECT = 'GET_COST_PROVIDER_REJECT';

//* ACTIONS ------------------------------------------------
export const getCostProviderLoading = () => ({ type: GET_COST_PROVIDER_LOADING });
export const getCostProviderSuccess = (payload) => ({ type: GET_COST_PROVIDER_SUCCESS, payload });
export const getCostProviderReject = (payload) => ({ type: GET_COST_PROVIDER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getCostProviderRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params: { ...data, Export: false, IsAutomatic: false },
    }, getState);
    return request(`/Providers/web/GetAllProviderCosts`, options);
};

